import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enCommon from "@/locales/en/common";
import enNavigation from "@/locales/en/navigation";
import enAccounts from "@/locales/en/pages/accounts";
import enActivity from "@/locales/en/pages/activity";
import enAddressBook from "@/locales/en/pages/address-book";
import enAuth from "@/locales/en/pages/auth";
import enCalendar from "@/locales/en/pages/calendar";
import enContainers from "@/locales/en/pages/containers";
import enDashboard from "@/locales/en/pages/dashboard";
import enDocuments from "@/locales/en/pages/documents";
import enDocumentsAdmin from "@/locales/en/pages/documents-admin";
import enKnowledgeAdmin from "@/locales/en/pages/knowledge-admin";
import enLanding from "@/locales/en/pages/landing";
import enOrders from "@/locales/en/pages/orders";
import enQuotes from "@/locales/en/pages/quotes";
import enReceivers from "@/locales/en/pages/receivers";
import enSettings from "@/locales/en/pages/settings";
import enSettingsAdmin from "@/locales/en/pages/settings-admin";
import enShippers from "@/locales/en/pages/shippers";
import enTeam from "@/locales/en/pages/team";
import enWorkflowsAdmin from "@/locales/en/pages/workflows-admin";
import enTypes from "@/locales/en/types";
import esCommon from "@/locales/es/common";
import esNavigation from "@/locales/es/navigation";
import esAccounts from "@/locales/es/pages/accounts";
import esActivity from "@/locales/es/pages/activity";
import esAddressBook from "@/locales/es/pages/address-book";
import esAuth from "@/locales/es/pages/auth";
import esCalendar from "@/locales/es/pages/calendar";
import esContainers from "@/locales/es/pages/containers";
import esDashboard from "@/locales/es/pages/dashboard";
import esDocuments from "@/locales/es/pages/documents";
import esDocumentsAdmin from "@/locales/es/pages/documents-admin";
import esKnowledgeAdmin from "@/locales/es/pages/knowledge-admin";
import esLanding from "@/locales/es/pages/landing";
import esOrders from "@/locales/es/pages/orders";
import esQuotes from "@/locales/es/pages/quotes";
import esReceivers from "@/locales/es/pages/receivers";
import esSettings from "@/locales/es/pages/settings";
import esSettingsAdmin from "@/locales/es/pages/settings-admin";
import esShippers from "@/locales/es/pages/shippers";
import esTeam from "@/locales/es/pages/team";
import esWorkflowsAdmin from "@/locales/es/pages/workflows-admin";
import esTypes from "@/locales/es/types";
import itCommon from "@/locales/it/common";
import itNavigation from "@/locales/it/navigation";
import itAccounts from "@/locales/it/pages/accounts";
import itActivity from "@/locales/it/pages/activity";
import itAddressBook from "@/locales/it/pages/address-book";
import itAuth from "@/locales/it/pages/auth";
import itCalendar from "@/locales/it/pages/calendar";
import itContainers from "@/locales/it/pages/containers";
import itDashboard from "@/locales/it/pages/dashboard";
import itDocuments from "@/locales/it/pages/documents";
import itDocumentsAdmin from "@/locales/it/pages/documents-admin";
import itKnowledgeAdmin from "@/locales/it/pages/knowledge-admin";
import itLanding from "@/locales/it/pages/landing";
import itOrders from "@/locales/it/pages/orders";
import itQuotes from "@/locales/it/pages/quotes";
import itReceivers from "@/locales/it/pages/receivers";
import itSettings from "@/locales/it/pages/settings";
import itSettingsAdmin from "@/locales/it/pages/settings-admin";
import itShippers from "@/locales/it/pages/shippers";
import itTeam from "@/locales/it/pages/team";
import itWorkflowsAdmin from "@/locales/it/pages/workflows-admin";
import itTypes from "@/locales/it/types";

const resources = {
    en: {
        common: enCommon,
        navigation: enNavigation,
        types: enTypes,
        "pages:auth": enAuth,
        "pages:dashboard": enDashboard,
        "pages:containers": enContainers,
        "pages:documents": enDocuments,
        "pages:team": enTeam,
        "pages:address-book": enAddressBook,
        "pages:settings": enSettings,
        "pages:activity": enActivity,
        "pages:accounts": enAccounts,
        "pages:settings-admin": enSettingsAdmin,
        "pages:documents-admin": enDocumentsAdmin,
        "pages:workflows-admin": enWorkflowsAdmin,
        "pages:knowledge-admin": enKnowledgeAdmin,
        "pages:receivers": enReceivers,
        "pages:shippers": enShippers,
        "pages:calendar": enCalendar,
        "pages:orders": enOrders,
        "pages:quotes": enQuotes,
        "pages:landing": enLanding,
    },
    it: {
        common: itCommon,
        navigation: itNavigation,
        types: itTypes,
        "pages:auth": itAuth,
        "pages:dashboard": itDashboard,
        "pages:containers": itContainers,
        "pages:documents": itDocuments,
        "pages:team": itTeam,
        "pages:address-book": itAddressBook,
        "pages:settings": itSettings,
        "pages:activity": itActivity,
        "pages:accounts": itAccounts,
        "pages:settings-admin": itSettingsAdmin,
        "pages:documents-admin": itDocumentsAdmin,
        "pages:workflows-admin": itWorkflowsAdmin,
        "pages:knowledge-admin": itKnowledgeAdmin,
        "pages:receivers": itReceivers,
        "pages:shippers": itShippers,
        "pages:calendar": itCalendar,
        "pages:orders": itOrders,
        "pages:quotes": itQuotes,
        "pages:landing": itLanding,
    },
    es: {
        common: esCommon,
        navigation: esNavigation,
        types: esTypes,
        "pages:auth": esAuth,
        "pages:dashboard": esDashboard,
        "pages:containers": esContainers,
        "pages:documents": esDocuments,
        "pages:team": esTeam,
        "pages:address-book": esAddressBook,
        "pages:settings": esSettings,
        "pages:activity": esActivity,
        "pages:accounts": esAccounts,
        "pages:settings-admin": esSettingsAdmin,
        "pages:documents-admin": esDocumentsAdmin,
        "pages:workflows-admin": esWorkflowsAdmin,
        "pages:knowledge-admin": esKnowledgeAdmin,
        "pages:receivers": esReceivers,
        "pages:shippers": esShippers,
        "pages:calendar": esCalendar,
        "pages:orders": esOrders,
        "pages:quotes": esQuotes,
        "pages:landing": esLanding,
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        defaultNS: "common",
        ns: [
            "common",
            "navigation",
            "types",
            "pages:auth",
            "pages:dashboard",
            "pages:containers",
            "pages:documents",
            "pages:team",
            "pages:address-book",
            "pages:settings",
            "pages:activity",
            "pages:accounts",
            "pages:settings-admin",
            "pages:documents-admin",
            "pages:workflows-admin",
            "pages:knowledge-admin",
            "pages:receivers",
            "pages:shippers",
            "pages:calendar",
            "pages:orders",
            "pages:quotes",
            "pages:landing",
        ],
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
    });

// Assicurati che la lingua sia sempre 'en' se non è stata esplicitamente impostata dall'utente
const savedLanguage = localStorage.getItem("i18nextLng");
if (!savedLanguage || (savedLanguage !== "en" && savedLanguage !== "it" && savedLanguage !== "es")) {
    i18n.changeLanguage("en");
    localStorage.setItem("i18nextLng", "en");
} else if (savedLanguage === "en" || savedLanguage === "it" || savedLanguage === "es") {
    // Se c'è una lingua valida salvata, usala
    i18n.changeLanguage(savedLanguage);
}

export default i18n;
